import { render } from "./warehouse.vue?vue&type=template&id=4aaec77e&scoped=true&ts=true"
import script from "./warehouse.vue?vue&type=script&lang=ts"
export * from "./warehouse.vue?vue&type=script&lang=ts"

import "./warehouse.vue?vue&type=style&index=0&id=4aaec77e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aaec77e"]])

export default __exports__